import { useState, useMemo, useCallback } from "react";

/**
 * Hook para manejar paginación de servicios
 */
export const usePagination = (items, itemsPerPage = 50) => {
  const [page, setPage] = useState(1);

  const paginatedItems = useMemo(() => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return items.slice(startIndex, endIndex);
  }, [items, page, itemsPerPage]);

  const totalPages = Math.ceil(items.length / itemsPerPage);

  const goToPage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  // Reset to page 1 when items change
  const resetPagination = useCallback(() => {
    setPage(1);
  }, []);

  return {
    page,
    totalPages,
    paginatedItems,
    goToPage,
    onPageChange: goToPage,
    resetPagination,
    itemsPerPage,
    totalItems: items.length,
  };
};

